const options = {
  5: "bg-red-50/5",
  10: "bg-red-50/10",
  25: "bg-red-50/25",
  50: "bg-red-50/50",
  75: "bg-red-50/75",
  90: "bg-red-50/90",
  100: "bg-red-50",
};

const from = {
  5: "from-red-50/5",
  10: "from-red-50/10",
  25: "from-red-50/25",
  50: "from-red-50/50",
  75: "from-red-50/75",
  90: "from-red-50/90",
  100: "from-red-50",
};

export default function getBackgroundRed50(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
